import React from 'react';
import comingSoon from '../../assets/comingSoon.gif';
import './comingsoon.css';

const ComingSoon = () => {
  return (
    <section id="ComingSoon" className="comingSoon">
      <div>
        <img src={comingSoon} className="comingSoon-img" alt="Coming Soon" />
      </div>
    </section>
  );
};

export default ComingSoon;
